/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Search_No_ResultsInputs */

const vi_map_search_no_results = /** @type {(inputs: Map_Search_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy địa điểm nào khớp, hãy gõ tên khác hoặc dán toạ độ`)
};

/**

* @param {Map_Search_No_ResultsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const map_search_no_results = /** @type {((inputs?: Map_Search_No_ResultsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Search_No_ResultsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_map_search_no_results(inputs)
});